import { BatchChangeDTO, BatchDTO, BatchFileFilterResponse, BatchFileStatisticsDTO, BatchInfoGetResponse, SiteDTO, SiteID, SyncBatch, UUIDv1 } from '@beable/roster-backend-client-v1';
import RosterBackendService from './RosterBackendService';

async function getBatches(siteId: number): Promise<BatchDTO[] | null> {
    const response = await RosterBackendService.getBatches(siteId);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function getBatchStatistics(batchId: string): Promise<BatchFileStatisticsDTO[] | null> {
    const response = await RosterBackendService.getBatchStatistics(batchId);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function getBatchFilteredData(batchId: string, page: number, fileName: string): Promise<BatchFileFilterResponse | null> {
    const response = await RosterBackendService.getBatchFilteredData(batchId, page, fileName);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function getBatchChangeReport(batchId: string, fileName: string | null): Promise<BatchChangeDTO | null> {
    const response = await RosterBackendService.getBatchChangeReport({ batchId, fileName });
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function rejectBatch(batchId: string): Promise<boolean | null> {
    const response = await RosterBackendService.rejectBatch({ batchId });
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function resumeBatch(batchId: string): Promise<BatchDTO | null> {
    const response = await RosterBackendService.resumeBatch({ body: { batchId } });
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function approveBatch(siteId: SiteID, syncBatchId: UUIDv1, adminAccountId?: string): Promise<SyncBatch | null> {
    const response = await RosterBackendService.approveBatch(siteId, syncBatchId, adminAccountId);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function createEmployeeBatch(site: SiteDTO, firstName: string, lastName: string, noLoginSuffix: boolean) {
    //const noLoginSuffix = ['eval','training'].includes(site.subdomain);
    const response = await RosterBackendService.createEmployeeBatch({
        siteId: site.id,
        firstName,
        lastName,
        sitePurl: site.subdomain,
        noLoginSuffix
    });

    if (response.isOk()) {
        return response.value.users;
    }

    return null;
}

async function removeEmployeeBatch(site: SiteDTO, orgId: string) {
    const response = await RosterBackendService.removeEmployeeBatch({
        siteId: site.id,
        sitePurl: site.subdomain,
        orgId
    });

    if (response.isOk()) {
        return response.value;
    }

    return null;
}

async function checkEmployeeBatchInProgress(siteId: number) {
    const response = await RosterBackendService.batchInProgress(siteId);

    if (response.isOk()) {
        return response.value;
    }

    return null;
}

async function cancelBatch(legacyBatchId: UUIDv1, siteId: number): Promise<boolean | null> {
    const response = await RosterBackendService.cancelBatch(legacyBatchId, siteId);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

async function getSyncBatches(siteId: number, count?: number): Promise<SyncBatch[] | null> {
    const response = await RosterBackendService.syncBatchesGet({ siteId: siteId as SiteID, count });
    if (response.isOk()) {
        return response.value.batches;
    } else {
        return null;
    }
}

async function getBatchInfo(params: { siteId: SiteID, syncBatchIds: UUIDv1[], legacyBatchIds: UUIDv1[] }): Promise<BatchInfoGetResponse | null> {
    const response = await RosterBackendService.batchInfoGet(params);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

export default {
    getBatches,
    getBatchStatistics,
    getBatchFilteredData,
    getBatchChangeReport,
    resumeBatch,
    approveBatch,
    rejectBatch,
    createEmployeeBatch,
    removeEmployeeBatch,
    checkEmployeeBatchInProgress,
    cancelBatch,
    getSyncBatches,
    getBatchInfo,
}

